import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    APPLICANT_CONTACT,
    BILLING_ADDRESS,
    EXPRESS_LETTER_SERVICES,
    OTHER_DETAILS,
    PERSON_CONTACT,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/expressLetter';
import commonPayload from '../common';

export const formatELS = async (licenceDetails: any, caseTypeID: any) => {

    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    const billingData = commonPayload.getBillingData(licenceDetails);
    const contactPersonParticulars = commonPayload.getContactPersonParticulars(licenceDetails);
    const billingPersonParticulars = commonPayload.getBillingPersonParticulars(licenceDetails);
    newDocs = await requestLicenceAttachment(
        licenceDetails?.supportingDocuments?.supportingDocumentsToSupportTheAmendmentApplication,
        caseTypeID
    );

    newPayload = attachmentPayloadSetting([newDocs]);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'express-letter',
        formID: 'express-letter',
        hasError: true,
        title: 'Application Details',
        values: {
            ...contactPersonParticulars,
            ...billingPersonParticulars,
            ...billingData,
            [`${EXPRESS_LETTER_SERVICES}-types-express-letter`]:
                licenceDetails?.expressLetterServices?.typeOfExpressLetterServices ?? '',

            [`${EXPRESS_LETTER_SERVICES}-public-contact-no`]: licenceDetails?.otherDetails?.publicContactNo ?? '',
            [`${EXPRESS_LETTER_SERVICES}-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '',
            [`${EXPRESS_LETTER_SERVICES}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
}

const elsPayload = {
    formatELS
};

export default elsPayload;